import type { AspirantDocument } from '@/types/documents'

export const getUniqueDocumentId = (document: AspirantDocument): string => {
    if (document.idSapDocumentSubtest) {
        return `sap_${document.idSapDocumentSubtest}`
    }
    if (document.idAdditionalDocument) {
        return `additional_${document.idAdditionalDocument}`
    }

    return `generic_${document.idDocumentType}`
}

export const getFieldName = (
    document: AspirantDocument,
    index?: number
): string => {
    const uniqueId = getUniqueDocumentId(document)

    // Si idDocumentType es undefined, usar el índice como fallback
    if (document.idDocumentType === undefined && index !== undefined) {
        return `documentType_index_${index}`
    }

    return `documentType_${uniqueId}`
}
